<template>
  <div>
    <!--        <breadcrumb :routerList="[{to:'/establish/contractlist',title:'返利管理'},{title:'返利合同列表'}]"/>-->
    <Breadtabsheader/>
    <div class="h-content">

      <!--查询表单-->
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="合同类型" prop="productTypeLike">
                <brselect
                    style="width:100%;"
                    ref="productTypeLike"
                    clearable category="fl_rebate_type"
                    :v="q.productTypeLike"
                    v-model="q.productTypeLike">
                </brselect>
              </el-form-item>
              <el-form-item label="　经销商名称" prop="agentNameLike">
                <el-input v-model="q.agentNameLike" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="　经销商编码" prop="agentCodeLike">
                <el-input v-model="q.agentCodeLike" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="经销商类型" prop="agentNameLike">
                <brselect category="fl_agent_type" :v="q.agentType" v-model="q.agentType" :clearable="true"/>
              </el-form-item>
            </div>
            <el-collapse-transition>
              <div v-show="isScreen">
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="　　合同开始时间" class="nianboxs">
                    <el-date-picker
                        style="width: 100%;"
                        v-model="q.date"
                        :clearable="true"
                        type="month"
                        value-format="yyyy-MM"
                        placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="合同退出时间" style="width: 50%;" class="nianboxs">
                    <el-date-picker
                        v-model="q.tuichudatestart"
                        :clearable="true"
                        type="month"
                        value-format="yyyy-MM">
                    </el-date-picker>
                    <span class="w-time-to">至</span>
                    <el-date-picker
                        v-model="q.tuichudateend"
                        :clearable="true"
                        type="month"
                        value-format="yyyy-MM">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="合同状态" class="nianboxs">
                    <el-select  v-model="q.planStatus" placeholder="请选择" clearable >
                      <el-option label="正常在签" value="2"></el-option>
                      <el-option label="已退出" value="5"></el-option>
                      <el-option label="退出审批中" value="4"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </el-collapse-transition>
          </el-form>
          <div class="l-screenBox">
            <div class="l-screen" @click="collapseChange">
              <img :src="isScreen?closeScreen:drawScreen" alt="">
              <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
            </div>
            <div class="l-retrieval">
              <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
              <el-button class="h-btn h-formBtn h-bgwhite" @click="qingkong">重置</el-button>
            </div>
          </div>
        </div>
      </div>


      <!--展示表格-->
      <div class="h-table h-mrt30">
        <el-table @selection-change="handleSelectionChange"
                  ref="ddtable"
                  :data="tableData"
                  stripe
                  style="width: 100%"
                  :border="true"
                  max-height="430"
        >
          <el-table-column
              type="selection"
          >
          </el-table-column>
          <el-table-column
              type="index"
              label="#"
              width="40">
          </el-table-column>

          <el-table-column
              prop="productType"
              :show-overflow-tooltip="true"
              label="合同类型"
              width="80"
          >
            <template slot-scope="scope">
              {{scope.row.productType|dictname('fl_rebate_type')}}
            </template>

          </el-table-column>
          <el-table-column
              prop="area"
              :show-overflow-tooltip="true"
              label="区域" width="80"
          >
            <template slot-scope="scope">
              {{scope.row.area}}
            </template>
          </el-table-column>
          <el-table-column
              prop="agentName"
              :show-overflow-tooltip="true"
              label="经销商名称"
              min-width="170"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.agentName}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="agentCode"
              :show-overflow-tooltip="true"
              label="经销商编码" width="100"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.agentCode}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="agentType"
              label="经销商类型"
              :show-overflow-tooltip="true"
              width="100">
            <template slot-scope="scope">
              {{scope.row.agentType|dictname('fl_agent_type')}}
            </template>
          </el-table-column>
          <el-table-column
              prop="contractStartTime"
              :show-overflow-tooltip="true"
              label="合同开始时间"
              width="110">
          </el-table-column>
          <el-table-column
              prop="contractEndTime"
              :show-overflow-tooltip="true"
              label="合同结束时间"
              width="110">
          </el-table-column>
          <el-table-column
              prop="contractOutTime"
              :show-overflow-tooltip="true"
              label="合同退出时间"
              width="110">
          </el-table-column>

          <el-table-column
              prop="cdate"
              :show-overflow-tooltip="true"
              label="合同创建时间"
              width="110"
          >
          </el-table-column>
          <el-table-column
              prop="status"
              :show-overflow-tooltip="true"
              label="合同状态"
              width="120"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.planStatus == 5">已退出</div>
              <div v-if="scope.row.planStatus == 2">有效</div>
              <div v-if="scope.row.planStatus == 4">退出平台审批中</div>
              <div v-if="scope.row.planStatus == 7">退出省区经理审批中</div>
              <div v-if="scope.row.planStatus == 8">退出总监审批中</div>
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              width="240"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                <el-button
                    type="text"
                    size="small"
                    class="h-tableLink h-btn"
                    v-if="scope.row.planStatus==4">
                  已提交
                </el-button>
                <el-button
                    class="h-tableLink h-btn"
                    size="small"
                    type="text"
                    @click="handleTuichu(scope.row)"
                    v-if="(scope.row.planStatus==2 || scope.row.planStatus==3) && scope.row.contractEndTime > nowdate"
                    v-auth="'fllb_tuichu'"
                >退出
                </el-button>
                <el-button
                    type="text"
                    size="small"
                    class="h-tableLink h-btn"
                    v-if="scope.row.instid != '' && scope.row.instid != null"
                    @click="genzongLiuch(scope.row)">跟踪审批
                </el-button>
                <el-button
                    type="text"
                    size="small"
                    class="h-tableLink h-btn" @click="chakan(scope.row)"
                >
                  查看
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel" v-auth="'mbtc_daochu'"

            >批量导出
            </el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query"/>
          </div>
        </div>
      </div>
    </div>
    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    <!-- 业务归属谈判结果：（下拉筐选择：完成、未完成）
        承接方：文字填写。
        库存处理结果：（下拉筐选择：完成、未完成）
        承接方：文字填写。
        退出原因: 文字填写
        注: 全部为必填项,全部填写才可正常上传附件
                fileId  附件id
        businessResult 业务归属谈判结果
        businessResultReceiver 业务归属谈判结果承接方
        inventoryResult 库存处理结果
        inventoryResultReceiver 库存处理结果承接方-->
    <el-dialog title="合同退出" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="业务归属谈判结果" :label-width="formLabelWidth">
          <el-select v-model="form.businessResult" placeholder="请选择业务归属谈判结果">
            <el-option label="完成" value="完成"></el-option>
            <el-option label="未完成" value="未完成"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务归属谈判结果承接方" :label-width="formLabelWidth">
          <el-input v-model="form.businessResultReceiver" placeholder="请填写业务归属谈判结果承接方" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="库存处理结果" :label-width="formLabelWidth">
          <el-select v-model="form.inventoryResult" placeholder="请选择库存处理结果">
            <el-option label="完成" value="完成"></el-option>
            <el-option label="未完成" value="未完成"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="库存处理结果承接方" :label-width="formLabelWidth">
          <el-input v-model="form.inventoryResultReceiver" placeholder="请填写库存处理结果承接方" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="退出原因" :label-width="formLabelWidth">
          <el-input v-model="form.reason" placeholder="请填写退出原因" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="请上传附件" :label-width="formLabelWidth" class="h-elformWrap-2">
          <el-upload
              v-model="form.fileId"
              class="upload-demo"
              action=""
              :http-request="httpRequestAgent3"
              :on-remove="handleRemoveAgent3"
              :before-remove="beforeRemove"
              :before-upload="beforeUpload"
              :file-list="fileListAgent"
              :auto-upload=true>
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureTuichu">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ss from '../../../api/SystemService'
import updownfile from '../../../utils/updownfile'
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import uploadFile from "../../../api/process/account_complainUploadService";
import uploaddown from '../../../utils/updownfile'

export default {
  components: {
    uploaddownexcel,
  },
  data() {
    return {
      // 展开折叠筛选
      isScreen:false,
      closeScreen:require("@/assets/images/pimg/closeallic.png"),
      drawScreen:require("@/assets/images/pimg/dobleArr.png"),
      check1:true,
      ht: '',
      nowdate: this.$util.riQi(new Date()),
      uploaddownexcelflag: false,
      uploaddownexcelflagXsjl: false,
      timeValue: null,
      value2: '',
      showhistory: false,
      instid: '',
      taskid: '',
      //查询属性
      page: {
        contractBaseId: '',
        pageSize: 20,
        pageNo: 1
      },
      q: {
        //timeValue: null,
        contractNameLike: '',
        agentNameLike: '',
        agentCodeLike:'',
        startCdate: '',
        endCdate: '',
        taskid: '',
        pageSize: 10,
        pageNo: 1,
        total: 0,
        date: '2026-01'
      },
      //表单
      f: {
        pageNo: 1,
        id: null, //
        contractBaseId: null, //
        agentName: null, //
        agentCode: null, //
        contractStartTime: null, //
        contractEndTime: null, //
        contractOutTime: null, //
        areaCode: null, //
        area: null, //
        channelCode: null, //
        channel: null, //
        cdate: null, //
        ldate: null, //
        cucode: null, //
        cuname: null, //
        lucode: null, //
        delflag: null, //
      },
      //表格
      multipleSelection: [],

      //table列表
      tableData: [],
      flag: 0,
      //操作标志
      optflag: 'save',
      dialogFormVisible: false,
      // 离开原因表单
      form: {
        fileId:'' ,//附件id
        businessResult :'',//业务归属谈判结果
        businessResultReceiver :"",//业务归属谈判结果承接方
        inventoryResult:"", //库存处理结果
        inventoryResultReceiver:"", //库存处理结果承接方
        reason:"",//退出原因,
        contractId:'',
      },
      rowdata:null,
      fileListAgent: [],
      formLabelWidth: '180px',
      fileList:[],
    }
  },
  created() {
    this.query();
    console.log(this.nowdate)
  },
  beforeRouteLeave(to, from, next) {
    from.meta.keepAlive = false;
    next();
  },
  computed: {
  },
  methods: {
    // 展开折叠
    collapseChange(){
      this.isScreen = !this.isScreen;
    },
    uploadExcelFilecallback() {
      this.query();
      this.$msg.msgs(rd.msg);
    },

    //跟踪审批
    genzongLiuch(v) {
      console.log("instid", v);
      this.instid = v.instid;
      console.log(this.instid+"!!!!@@@@@@")
      this.showhistory = true;
    },

    //检索时间
    timeSelect() {
      if (this.timeValue == null || this.timeValue == '') {
        this.q.startCdate = null;
        this.q.endCdate = null;
      } else {
        this.q.startCdate = this.timeValue[0];
        this.q.endCdate = this.timeValue[1];
      }
    },
    //重置
    qingkong() {
      this.timeValue = null,
          this.productTypeLike = null,
          // this.$refs["form"].resetFields();
          this.q = {
            pageSize: 10,
            pageNo: 1,
            total: 0,
          }
      // ss.fanli.pageDaoru(this.q).then(rd => {
      //
      // });
      this.query();
    },

    //新增
    adduser() {
      this.f.contractBaseId = '';
      this.f.agentName = '';
      this.f.contractStartTime = '';
      this.f.contractEndTime = '';
      this.f.contractOutTime = '';
      this.f.cdate = '';

    },
    query() {
      ss.fanli.page(this.q).then(rd => {
        console.log(rd, "AAAAAA");
        if (new Date() > this.f.contractEndTime) {
          console.log("!!!!!!!!!!");
        }
        ;

        this.q.total = rd.total;
        this.tableData = rd.records;
      });
    },
    daoruExcel() {
      ss.fanli.daoru(this.q).then(rd => {
        console.log(rd, "AAAAAA");
      });
    },
    //点击查看详情
    chakan(item) {
      console.log('行', item)
      this.$router.push({path: '/establish/agentContract', query: {id: item.id}});
    },
    //点击退出
    handleTuichu(item) {
      console.log('行', item)
      this.rowdata = item;
      this.form.contractId = item.id;
      this.dialogFormVisible = true;
    },
    // 点击退出弹窗确认事件
    sureTuichu(){
      if(!this.form.businessResult){
        this.$message.error('请选择业务归属谈判结果');
        return false
      } else if(!this.form.businessResultReceiver){
        this.$message.error('请填写业务归属谈判结果承接方');
        return false
      } else if(!this.form.inventoryResult){
        this.$message.error('请选择库存处理结果');
        return false
      } else if(!this.form.inventoryResultReceiver){
        this.$message.error('请填写库存处理结果承接方');
        return false
      } else if(!this.form.reason){
        this.$message.error('请填写退出原因');
        return false
      } else if(!this.form.fileId){
        this.$message.error('请上传附件');
        return false
      }
      ss.fanli.tuichu({
        ...this.rowdata,//结构当前行信息
        fileId:this.form.fileId  ,//附件id
        businessResult:this.form.businessResult,// 业务归属谈判结果
        businessResultReceiver:this.form.businessResultReceiver, //业务归属谈判结果承接方
        inventoryResult:this.form.inventoryResult,  // 库存处理结果
        inventoryResultReceiver:this.form.inventoryResultReceiver, // 库存处理结果承接方
        tuichuYuanyin:this.form.reason//推出原因
      }).then(rd => {
        // this.query();
        this.dialogFormVisible = false;
        this.$message({
          type: 'success',
          message: '提交成功,请联系相关负责人审核！'
        });
        this.query();
      });
    },
    handleFilter() {
      // this.q.pageNo=1;
      this.query();
      // this.search();
    },

    //勾选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //批量导出
    // exportExcel() {
    //     var idlist = [];
    //     this.multipleSelection.forEach(element => {
    //         idlist.push(element.id);
    //     });
    //     // this.q.ids = idlist.join(",");
    //     updownfile.down("/api/swyl/v1/fanli/hetong/flContractAgent/downloadExcel", idlist, "post", 'data');
    // },

    //批量导出
    exportExcel() {
      var idlist = [];
      this.multipleSelection.forEach(element => {
        idlist.push(element.id);
      });
      if (idlist.length != 0) {
        updownfile.down("/api/swyl/v1/fanli/hetong/flContractAgent/exportExcelByIds", idlist, "post", 'data');
      } else {
        updownfile.down("/api/swyl/v1/fanli/hetong/flContractAgent/exportExcelByEntity", this.q, "post");
      }
    },


    //导入
    uploaddownexcelflagbtn() {
      console.log("AA");
      this.uploaddownexcelflag = true;
    },
    httpRequestAgent3(params) {
      // console.log(params,"1111111111")
      const loading = this.$msg.loading("上传中...");
      uploaddown.upload(params.file, {refid: this.form.contractId, reftype: "传统合同退出附件"}).then(rd => {
        console.log("上传完毕后", rd);
        loading.close();
        this.form.fileId = rd.obj.id;
        this.fileListAgent = [rd.obj];
      }).catch(error => {
        loading.close();
        this.fileListAgent = [rd.obj];
        return Promise.reject(error);
      });
      return false;
    },

    handleRemoveAgent3(file) {
      console.log(file, "aaaaa");
      //删除文件
      var id = file.id;
      uploadFile.deleteById(id).then(response => {
        // console.log(response,"删除")
      })
      this.fileListAgent = [];
    },
    beforeRemove(file) {
      if (file && file.status === "success") {
        return this.$confirm(`确定移除 ${ file.name }？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        });
      }
    },
    confirmEnding(str, target) {
      var start = str.length - target.length;
      var arr = str.substr(start, target.length);
      if (arr == target) {
        return true;
      }
      return false;
    },
    beforeUpload(file) {
      // const isFile = file.type === 'image/jpg'||file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
      // const isLt5M = file.size / 1024 / 1024 < 5;
      var pdf = this.confirmEnding(file.name, ".pdf");
      if (pdf == false) {
        this.$message.error("请上传PDF格式的文件！");
        return false;
      }
      // fileId  附件id
      // businessResult 业务归属谈判结果
      // businessResultReceiver 业务归属谈判结果承接方
      // inventoryResult 库存处理结果
      // inventoryResultReceiver 库存处理结果承接方
      if (!this.form.businessResult) {
        this.$message.error('请选择业务归属谈判结果');
        return false
      } else if (!this.form.businessResultReceiver) {
        this.$message.error('请填写业务归属谈判结果承接方');
        return false
      } else if (!this.form.inventoryResult) {
        this.$message.error('请选择库存处理结果');
        return false
      } else if (!this.form.inventoryResultReceiver) {
        this.$message.error('请填写库存处理结果承接方');
        return false
      }
    }

  }
}
</script>
<style>
.sjwpicker .el-date-editor .el-range-separator {
  width: 8%;
  line-height: 0.35rem;
}
</style>